import { history } from '../Router'
import { put, select, call } from 'redux-saga/effects'
import * as actions from '../store/actions'
import {store} from '../Store'



export function * searchFlow (payload) {
  try {
    yield put(actions.searchMerchants(payload.token, payload.search, payload.user))
  } catch (error) {
    console.log(error)
  }
}

export function * searchResultsFlow (payload) {
  try {
    let url = `/search`
    if (payload.merchants && payload.merchants.length === 1){
      yield put({ type: 'FETCH_MERCHANT_SUCCESS', merchant: payload.merchants[0] })
      url = `/merchants/${payload.merchants[0].resource_id}`
    }
    if (payload.merchants && payload.merchants.length > 1){
      yield put({ type: 'FETCH_MERCHANT_SUCCESS', merchants: payload.merchants })
      url = `/search`
    }
    // document.location.href = url

    // console.log('history', history)
    // console.log('router_history', router_history)
    
    // yield history.push(url)
    // yield put(history.push(url));
    // yield put({ type: 'NAVIGATE_SEARCH' })
    // actions.navigateSearch(history)
    // yield history.go(url)
    // window.location.replace = url
    // yield call(history.push, url)
    // yield call(router_history.push, url)
    // yield cps(history.push, url)
    // navigate(url)
  } catch (error) {
    console.log(error)
  }
}